import React from 'react';

import { lazyWithRetry } from '@app/helpers/LazyHelper';

import PageLayout from '@app/partials/layout/PageLayout';

const Service = lazyWithRetry(() => import('@app/pages/autouser/services/Service'));
const Services = lazyWithRetry(() => import('@app/pages/autouser/services/Services'));
const ServicesSubHeader = lazyWithRetry(() => import('@app/pages/autouser/services/ServicesSubHeader'));

const ContactInquiriesSubHeader = lazyWithRetry(() => import('@app/pages/contactInquiries/ContactInquiriesSubHeader'));
const CustomerContacts = lazyWithRetry(() => import('@app/pages/customers/Partials/CustomerContacts/CustomerContacts'));

const Account = lazyWithRetry(() => import('@app/pages/account/Account'));
const AchatCash = lazyWithRetry(() => import('@app/pages/achatCash/AchatCash'));
const Alerts = lazyWithRetry(() => import('@app/pages/administration/alerts/Alerts'));
const AlertSubHeader = lazyWithRetry(() => import('@app/pages/administration/alerts/AlertSubHeader'));
const ActionEmailType = lazyWithRetry(() => import('@app/pages/administration/email-template/ActionEmailType'));
const ActionEmailTypes = lazyWithRetry(() => import('@app/pages/administration/email-template/ActionEmailTypes'));
const ActionEmailTypeSubHeader = lazyWithRetry(
    () => import('@app/pages/administration/email-template/ActionEmailTypeSubHeader'),
);
const ConsoleLeads = lazyWithRetry(() => import('@app/pages/administration/leads/ConsoleLeads'));
const ConsoleRGPD = lazyWithRetry(() => import('@app/pages/administration/rgpd/ConsoleRGPD'));
const ConsoleRGPDSubHeader = lazyWithRetry(() => import('@app/pages/administration/rgpd/ConsoleRGPDSubHeader'));
const ActionSignatureType = lazyWithRetry(
    () => import('@app/pages/administration/signature-template/ActionSignatureType'),
);
const ActionSignatureTypes = lazyWithRetry(
    () => import('@app/pages/administration/signature-template/ActionSignatureTypes'),
);
const ActionSignatureTypeSubHeader = lazyWithRetry(
    () => import('@app/pages/administration/signature-template/ActionSignatureTypeSubHeader'),
);
const Agenda = lazyWithRetry(() => import('@app/pages/agenda/Agenda'));
const AdditionalService = lazyWithRetry(() => import('@app/pages/apv/additionals-services/AdditionalService'));
const AdditionalServices = lazyWithRetry(() => import('@app/pages/apv/additionals-services/AdditionalServices'));
const AdditionalServiceSubHeader = lazyWithRetry(
    () => import('@app/pages/apv/additionals-services/AdditionalServiceSubHeader'),
);
const APVInStoreOrder = lazyWithRetry(() => import('@app/pages/apv/apvinstore/APVInStoreDetails/Order'));
const APVInStoreOrderSubHeader = lazyWithRetry(
    () => import('@app/pages/apv/apvinstore/APVInStoreDetails/OrderSubHeader'),
);
const Categories = lazyWithRetry(() => import('@app/pages/apv/categories/Categories'));
const Category = lazyWithRetry(() => import('@app/pages/apv/categories/Category'));
const CategorySubHeader = lazyWithRetry(() => import('@app/pages/apv/categories/CategorySubHeader'));
const CommercialOperation = lazyWithRetry(() => import('@app/pages/apv/commercial-operation/CommercialOperation'));
const CommercialOperations = lazyWithRetry(() => import('@app/pages/apv/commercial-operation/CommercialOperations'));
const CommercialOperationSubHeader = lazyWithRetry(
    () => import('@app/pages/apv/commercial-operation/CommercialOperationSubHeader'),
);
const Dealership = lazyWithRetry(() => import('@app/pages/apv/dealerships/Dealership'));
const Dealerships = lazyWithRetry(() => import('@app/pages/apv/dealerships/Dealerships'));
const DealershipSubHeader = lazyWithRetry(() => import('@app/pages/apv/dealerships/DealershipSubHeader'));
const ApvInStoreOrders = lazyWithRetry(() => import('@app/pages/apv/instore_orders/Orders'));
const ApvInStoreQuotations = lazyWithRetry(() => import('@app/pages/apv/instore_quotations/Quotations'));
const ApvInStoreQuotationsSubHeader = lazyWithRetry(
    () => import('@app/pages/apv/instore_quotations/QuotationsSubHeader'),
);
const APVLeads = lazyWithRetry(() => import('@app/pages/apv/leads/Leads'));
const Order = lazyWithRetry(() => import('@app/pages/apv/orders/Order'));
const AutosphereOrder = lazyWithRetry(() => import('../pages/apv/autosphere_order/Order'));
const AutosphereOrderSubHeader = lazyWithRetry(() => import('../pages/apv/autosphere_order/OrderSubHeader'));
const Orders = lazyWithRetry(() => import('@app/pages/apv/orders/Orders'));
const AutosphereOrders = lazyWithRetry(() => import('@app/pages/apv/autosphere_orders/AutosphereOrdersPage'));
const AutosphereOrdersSubHeader = lazyWithRetry(
    () => import('@app/pages/apv/autosphere_orders/AutosphereOrdersSubHeader'),
);
const OrdersSubHeader = lazyWithRetry(() => import('@app/pages/apv/orders/OrdersSubHeader'));
const OrderSubHeader = lazyWithRetry(() => import('@app/pages/apv/orders/OrderSubHeader'));
const Package = lazyWithRetry(() => import('@app/pages/apv/packages/Package'));
const Packages = lazyWithRetry(() => import('@app/pages/apv/packages/Packages'));
const PackageSubHeader = lazyWithRetry(() => import('@app/pages/apv/packages/PackageSubHeader'));
const PackagesSubHeader = lazyWithRetry(() => import('@app/pages/apv/packages/PackagesSubHeader'));
const Applications = lazyWithRetry(() => import('@app/pages/autouser/applications/Applications'));
const Application = lazyWithRetry(() => import('@app/pages/autouser/applications/Application'));
const DealershipsPerimeter = lazyWithRetry(() => import('@app/pages/autouser/dealerships/DealershipsPerimeter'));
const History = lazyWithRetry(() => import('@app/pages/autouser/history/History'));
const Role = lazyWithRetry(() => import('@app/pages/autouser/roles/Role'));
const Roles = lazyWithRetry(() => import('@app/pages/autouser/roles/Roles'));
const RolesSubHeader = lazyWithRetry(() => import('@app/pages/autouser/roles/RolesSubHeader'));
const User = lazyWithRetry(() => import('@app/pages/autouser/users/User'));
const Users = lazyWithRetry(() => import('@app/pages/autouser/users/Users'));
const UserSubHeader = lazyWithRetry(() => import('@app/pages/autouser/users/UserSubHeader'));
const BulkQuotation = lazyWithRetry(() => import('@app/pages/administration/bulk-quotation/BulkQuotation'));
const Campaigns = lazyWithRetry(() => import('@app/pages/campaigns/Campaigns'));
const CampaignsSubHeader = lazyWithRetry(() => import('@app/pages/campaigns/CampaignsSubHeader'));
const Customer = lazyWithRetry(() => import('@app/pages/customers/Customer'));
const Customers = lazyWithRetry(() => import('@app/pages/customers/Customers'));
const CustomersActions = lazyWithRetry(() => import('@app/pages/customers/CustomersActions'));
const CustomersPortfolio = lazyWithRetry(() => import('@app/pages/customers/CustomersPortfolio'));
const CustomerSubHeader = lazyWithRetry(() => import('@app/pages/customers/CustomerSubHeader'));
const Dashboard = lazyWithRetry(() => import('@app/pages/dashboard/Dashboard'));
const Directory = lazyWithRetry(() => import('@app/pages/directory/Directory'));
const Fluidities = lazyWithRetry(() => import('@app/pages/fluidity/Fluidities'));
const Fluidity = lazyWithRetry(() => import('@app/pages/fluidity/Fluidity'));
const FluiditySubHeader = lazyWithRetry(() => import('@app/pages/fluidity/FluiditySubHeader'));
const LeadsOnline = lazyWithRetry(() => import('@app/pages/leadsOnline/LeadsOnline'));
const FinancingSimulation = lazyWithRetry(() => import('@app/pages/financing/FinancingSimulation'));
const FinancingWallet = lazyWithRetry(() => import('../pages/financing/FinancingWallet'));
const FinancingLeads = lazyWithRetry(() => import('../pages/financing/FinancingLeads'));
const ManufacturerOrder = lazyWithRetry(() => import('@app/pages/manufacturer/orders/Order'));
const ManufacturerOrders = lazyWithRetry(() => import('@app/pages/manufacturer/orders/Orders'));
const ManufacturerOrdersSubHeader = lazyWithRetry(() => import('@app/pages/manufacturer/orders/OrdersSubHeader'));
const ManufacturerOrderSubHeader = lazyWithRetry(() => import('@app/pages/manufacturer/orders/OrderSubHeader'));
const PackageMappingSubHeader = lazyWithRetry(
    () => import('@app/pages/manufacturer/package-mapping/PackagesMappingSubHeader'),
);
const PackagesMapping = lazyWithRetry(() => import('@app/pages/manufacturer/package-mapping/PackageMapping'));
const ManufacturerPackage = lazyWithRetry(() => import('@app/pages/manufacturer/packages/Package'));
const ManufacturerPackageSubHeader = lazyWithRetry(() => import('@app/pages/manufacturer/packages/PackageSubHeader'));
const SecuryWebContracts = lazyWithRetry(() => import('@app/pages/securyweb/SecurywebContracts'));
const SecuryWebReporting = lazyWithRetry(() => import('@app/pages/securyweb/SecurywebReporting'));
const Settings = lazyWithRetry(() => import('@app/pages/settings/Settings'));
const SettingsSubHeader = lazyWithRetry(() => import('@app/pages/settings/SettingsSubHeader'));
const LeadTags = lazyWithRetry(() => import('@app/pages/settings/tags/LeadTags'));
const SROrder = lazyWithRetry(() =>
    import('@app/pages/smartRepair/orders/Order').then((module) => ({ default: module.default })),
);
const SROrders = lazyWithRetry(() =>
    import('@app/pages/smartRepair/orders/Orders').then((module) => ({ default: module.default })),
);
const SROrderSubHeader = lazyWithRetry(() =>
    import('@app/pages/smartRepair/orders/OrderSubHeader').then((module) => ({ default: module.default })),
);
const SROrdersSubHeader = lazyWithRetry(() =>
    import('@app/pages/smartRepair/orders/OrdersSubHeader').then((module) => ({ default: module.default })),
);
const SRPackage = lazyWithRetry(() => import('@app/pages/smartRepair/packages/Package'));
const SRPackageSubHeader = lazyWithRetry(() => import('@app/pages/smartRepair/packages/PackageSubHeader'));
const Quotation = lazyWithRetry(() =>
    import('@app/pages/smartRepair/quotations/quotationDetails/Quotation').then((module) => ({
        default: module.default,
    })),
);
const Quotations = lazyWithRetry(() =>
    import('@app/pages/smartRepair/quotations/quotations/Quotations').then((module) => ({ default: module.default })),
);
const QuotationsSubHeader = lazyWithRetry(() =>
    import('@app/pages/smartRepair/quotations/quotations/QuotationsSubHeader').then((module) => ({
        default: module.default,
    })),
);
const QuotationSubHeader = lazyWithRetry(() =>
    import('@app/pages/smartRepair/quotations/quotations/QuotationsSubHeader').then((module) => ({
        default: module.default,
    })),
);
const StockActionsToDo = lazyWithRetry(() => import('@app/pages/stock/actions/todo/StockActionsToDo'));
const StockActionsToDoSubHeader = lazyWithRetry(() => import('@app/pages/stock/header/StockActionsToDoSubHeader'));
const StockPricingToDo = lazyWithRetry(() => import('@app/pages/stock/pricing/todo/StockPricingToDo'));
const StockVehicle = lazyWithRetry(() => import('@app/pages/stock/vehicle/StockVehicle'));
const StockVehicles = lazyWithRetry(() => import('@app/pages/stock/vehicles/StockVehicles'));
const StockVehiclesSubHeader = lazyWithRetry(() => import('@app/pages/stock/header/StockVehiclesSubHeader'));
const StockVehicleSubHeader = lazyWithRetry(() => import('@app/pages/stock/header/StockVehicleSubHeader'));
const ApplicationsSubHeader = lazyWithRetry(() => import('@app/pages/autouser/applications/ApplicationsSubHeader'));
const VcuDuplicates = lazyWithRetry(() => import('@app/pages/dataQuality/VcuDuplicates'));

const ROUTES = {
    DASHBOARD: {
        exact: true,
        PATH: '/dashboard',
        permissions: ['PROFILE_VIEW_DASHBOARD'],
        render: () => <PageLayout main={Dashboard} subheader={false} />,
    },
    AGENDA: {
        exact: true,
        PATH: '/agenda',
        permissions: ['LEAD_VIEW_CALENDAR'],
        render: () => <PageLayout main={Agenda} />,
    },
    PACKAGES: {
        exact: true,
        permissions: ['APV_LIST_PACKAGE'],
        PATH: {
            ALL: '/settings/apv/package',
            TYPE: '/settings/apv/package/:type(workshop|smartrepair|manufacturer)',
        },
        render: () => <PageLayout main={Packages} subheader={PackagesSubHeader} />,
    },
    PACKAGE: {
        exact: true,
        permissions: ['APV_LIST_PACKAGE'],
        PATH: {
            CREATE: '/settings/apv/package/workshop/new',
            UPDATE: '/settings/apv/package/workshop/:id(\\d+)',
        },
        render: () => <PageLayout main={Package} subheader={PackageSubHeader} />,
    },
    PACKAGE_SMARTREPAIR: {
        exact: true,
        permissions: ['SR_ADD_PACKAGE', 'SR_UPDATE_PACKAGE'],
        PATH: {
            CREATE: '/settings/apv/package/smartrepair/new',
            UPDATE: '/settings/apv/package/smartrepair/:id([A-Za-z0-9\\-\\=\\_]+)',
        },
        render: () => <PageLayout main={SRPackage} subheader={SRPackageSubHeader} />,
    },
    PACKAGE_MANUFACTURER: {
        exact: true,
        PATH: {
            CREATE: '/settings/apv/package/manufacturer/new',
            UPDATE: '/settings/apv/package/manufacturer/:id([A-Za-z0-9\\-\\=\\_]+)',
        },
        render: () => <PageLayout main={ManufacturerPackage} subheader={ManufacturerPackageSubHeader} />,
    },
    ORDER: {
        exact: true,
        permissions: ['APV_DETAILS_ORDER'],
        PATH: '/orders/:id([0-9a-fA-F\\-]+)',
        render: () => <PageLayout main={Order} subheader={OrderSubHeader} />,
    },
    AUTOSPHERE_ORDER: {
        exact: true,
        permissions: ['APV_DETAILS_ORDER'],
        PATH: '/autosphere_order/:id([A-Za-z0-9\\-]+)',
        render: () => <PageLayout main={AutosphereOrder} subheader={AutosphereOrderSubHeader} />,
    },
    ORDERS: {
        exact: true,
        permissions: ['APV_LIST_ORDER'],
        PATH: {
            ALL: '/orders',
            TYPE: '/orders/:type(commande|panier)',
        },
        render: () => <PageLayout main={Orders} subheader={OrdersSubHeader} />,
    },
    ORDERS_NEW: {
        exact: true,
        permissions: ['APV_LIST_ORDER'],
        PATH: {
            ALL: '/autosphere_orders',
            TYPE: '/autosphere_orders/:type(commande|panier)',
        },
        render: () => <PageLayout main={AutosphereOrders} subheader={AutosphereOrdersSubHeader} />,
    },
    APV_INSTORE_QUOTATIONS: {
        exact: true,
        permissions: ['APV_INSTORE_LIST_ORDER'],
        PATH: {
            ALL: '/apv/instore-quotations',
            TYPE: '/apv/instore-quotations/:type(draft|waiting_for_customer|closed)',
        },
        render: () => <PageLayout main={ApvInStoreQuotations} subheader={ApvInStoreQuotationsSubHeader} />,
    },
    APV_INSTORE_ORDERS: {
        exact: true,
        permissions: ['APV_INSTORE_LIST_ORDER'],
        PATH: '/apv/instore-orders',
        render: () => <PageLayout main={ApvInStoreOrders} />,
    },
    SMARTREPAIR_ORDER: {
        exact: true,
        permissions: ['SR_DETAILS_ORDER'],
        PATH: '/smartrepair/orders/:id([A-Za-z0-9\\-\\=\\_]+)',
        render: () => <PageLayout main={SROrder} subheader={SROrderSubHeader} />,
    },
    SMARTREPAIR_ORDERS: {
        exact: true,
        permissions: ['SR_LIST_ORDER'],
        PATH: {
            ALL: '/smartrepair/orders',
        },
        render: () => <PageLayout main={SROrders} subheader={SROrdersSubHeader} />,
    },
    MANUFACTURER_ORDER: {
        exact: true,
        PATH: '/manufacturer/orders/:id([A-Za-z0-9\\-\\=\\_]+)',
        render: () => <PageLayout main={ManufacturerOrder} subheader={ManufacturerOrderSubHeader} />,
    },
    MANUFACTURER_ORDERS: {
        exact: true,
        PATH: {
            ALL: '/manufacturer/orders',
        },
        render: () => <PageLayout main={ManufacturerOrders} subheader={ManufacturerOrdersSubHeader} />,
    },
    OPERATIONS: {
        exact: true,
        permissions: ['APV_LIST_COMMERCIAL_OPERATION'],
        PATH: '/settings/apv/operations',
        render: () => <PageLayout main={CommercialOperations} />,
    },
    OPERATION: {
        exact: true,
        permissions: ['APV_LIST_COMMERCIAL_OPERATION'],
        PATH: {
            CREATE: '/settings/apv/operations/new',
            UPDATE: '/settings/apv/operations/:id(\\d+)',
        },
        render: () => <PageLayout main={CommercialOperation} subheader={CommercialOperationSubHeader} />,
    },
    ADDITIONAL_SERVICES: {
        exact: true,
        permissions: ['APV_LIST_ADDITIONAL_SERVICE'],
        PATH: '/settings/apv/additional-services',
        render: () => <PageLayout main={AdditionalServices} />,
    },
    ADDITIONAL_SERVICE: {
        exact: true,
        permissions: ['APV_LIST_ADDITIONAL_SERVICE'],
        PATH: {
            CREATE: '/settings/apv/additional-services/new',
            UPDATE: '/settings/apv/additional-services/:id(\\d+)',
        },
        render: () => <PageLayout main={AdditionalService} subheader={AdditionalServiceSubHeader} />,
    },
    DEALERSHIPS: {
        exact: true,
        permissions: ['APV_LIST_PARAMS'],
        PATH: '/settings/apv/dealerships',
        render: () => <PageLayout main={Dealerships} />,
    },
    DEALERSHIP: {
        exact: true,
        permissions: ['APV_VIEW_PARAMS'],
        PATH: '/settings/apv/dealerships/:id',
        render: () => <PageLayout main={Dealership} subheader={DealershipSubHeader} />,
    },
    CATEGORIES: {
        exact: true,
        permissions: ['APV_LIST_CATEGORY'],
        PATH: '/settings/apv/categories',
        render: () => <PageLayout main={Categories} />,
    },
    CATEGORY: {
        exact: true,
        permissions: ['APV_LIST_CATEGORY'],
        PATH: {
            CREATE: '/settings/apv/categories/new',
            UPDATE: '/settings/apv/categories/:id(\\d+)',
        },
        render: () => <PageLayout main={Category} subheader={CategorySubHeader} />,
    },
    PACKAGES_MAPPING: {
        exact: true,
        PATH: '/settings/apv/package-mapping',
        render: () => <PageLayout main={PackagesMapping} subheader={PackageMappingSubHeader} />,
    },
    CUSTOMERS: {
        exact: true,
        PATH: '/customers',
        permissions: ['LEAD_SEARCH_CONTACT'],
        render: () => <PageLayout main={Customers} />,
    },
    SECURYWEB_CONTRACT: {
        exact: true,
        PATH: '/securyweb/contract',
        permissions: ['SECURYCAR_SEARCH_CONTRACT'],
        render: () => <PageLayout main={SecuryWebContracts} />,
    },
    SECURYWEB_REPORTING: {
        exact: true,
        PATH: '/securyweb/reporting',
        permissions: ['SECURYCAR_EXPORT_REPORT'],
        render: () => <PageLayout main={SecuryWebReporting} />,
    },
    ACTIONS: {
        exact: true,
        PATH: '/actions',
        permissions: ['LEAD_LIST_ACTION_TODO_CONTACT'],
        render: () => <PageLayout main={CustomersActions} />,
    },
    PORTFOLIO: {
        exact: true,
        PATH: '/portfolio',
        permissions: ['LEAD_VIEW_PORTFOLIO'],
        render: () => <PageLayout main={CustomersPortfolio} />,
    },
    CUSTOMER: {
        exact: true,
        PATH: '/customers/:id(\\d+)',
        permissions: ['LEAD_VIEW_CONTACT'],
        render: () => <PageLayout main={Customer} subheader={CustomerSubHeader} />,
    },
    CAMPAIGNS: {
        exact: true,
        PATH: '/campaigns',
        render: () => <PageLayout main={Campaigns} subheader={CampaignsSubHeader} />,
    },
    LEADS_ONLINE: {
        exact: true,
        PATH: '/leads-online/:statusType',
        render: () => <PageLayout main={LeadsOnline} />,
    },
    LEADS_ACHAT_CASH: {
        exact: true,
        PATH: {
            MAIN: '/leads-achat-cash/:statusType',
            ABANDON: '/leads-abandon/:statusType',
        },
        render: () => <PageLayout main={AchatCash} />,
    },
    FLUIDITIES: {
        exact: true,
        PATH: '/fluidity/:status',
        permissions: ['LEAD_LIST_FLUIDITE'],
        render: () => <PageLayout main={Fluidities} subheader={FluiditySubHeader} />,
    },
    FLUIDITY: {
        exact: true,
        PATH: '/fluidity/:status/:id(\\d+)',
        permissions: ['LEAD_VIEW_FLUIDITE'],
        render: () => <PageLayout main={Fluidity} subheader={FluiditySubHeader} />,
    },
    ACCOUNT_SETTINGS: {
        exact: true,
        PATH: '/account/settings',
        permissions: ['LEAD_VIEW_PROFIL'],
        render: () => <PageLayout main={Account} />,
    },
    ACCOUNT_PASSWORD: {
        exact: true,
        PATH: '/account/password',
        hasAnyPermissions: true,
        permissions: ['LEAD_UPDATE_PASSWORD_EXTERNAL_PROFIL', 'LEAD_UPDATE_PASSWORD_INTERNAL_PROFIL'],
        render: () => <PageLayout main={Account} />,
    },
    ACCOUNT_PLANNING: {
        exact: true,
        PATH: '/account/planning',
        permissions: ['LEAD_VIEW_CALENDAR_PROFIL'],
        render: () => <PageLayout main={Account} />,
    },
    ACCOUNT_HISTORY: {
        exact: true,
        PATH: '/account/history',
        permissions: ['LEAD_VIEW_HISTO_PROFIL'],
        render: () => <PageLayout main={Account} />,
    },
    ACCOUNT_PERIMETER: {
        exact: true,
        PATH: '/account/perimeter',
        permissions: ['LEAD_VIEW_SCOPE_PROFIL'],
        render: () => <PageLayout main={Account} />,
    },
    ACCOUNT_TEAM: {
        exact: true,
        PATH: '/account/team',
        permissions: ['LEAD_VIEW_TEAM'],
        render: () => <PageLayout main={Account} />,
    },
    EMAIL_TEMPLATES: {
        exact: true,
        permissions: ['PARAMETER_MANAGE_MAILTEMPLATE'],
        PATH: '/administration/email-templates',
        render: () => <PageLayout main={ActionEmailTypes} />,
    },
    EMAIL_TEMPLATE: {
        exact: true,
        permissions: ['PARAMETER_MANAGE_MAILTEMPLATE'],
        PATH: {
            CREATE: '/administration/email-templates/new',
            UPDATE: '/administration/email-templates/:id(\\d+)',
        },
        render: () => <PageLayout main={ActionEmailType} subheader={ActionEmailTypeSubHeader} />,
    },
    SIGNATURE_TEMPLATES: {
        exact: true,
        permissions: ['PARAMETER_MANAGE_SIGNATURE'],
        PATH: '/administration/signature-templates',
        render: () => <PageLayout main={ActionSignatureTypes} />,
    },
    SIGNATURE_TEMPLATE: {
        exact: true,
        permissions: ['PARAMETER_MANAGE_SIGNATURE'],
        PATH: {
            CREATE: '/administration/signature-templates/new',
            UPDATE: '/administration/signature-templates/:id(\\d+)',
        },
        render: () => <PageLayout main={ActionSignatureType} subheader={ActionSignatureTypeSubHeader} />,
    },
    USERS: {
        exact: true,
        PATH: '/autouser/users',
        permissions: ['AUTOUSER_LIST_USER'],
        render: () => <PageLayout main={Users} />,
    },
    USER: {
        exact: true,
        hasAnyPermissions: true,
        permissions: ['AUTOUSER_CREATE_USER', 'AUTOUSER_EDIT_USER'],
        PATH: {
            PASSWORD: '/autouser/users/:id(\\d+)/password',
            PLANNING: '/autouser/users/:id(\\d+)/planning',
            HISTORY: '/autouser/users/:id(\\d+)/history',
            PERIMETER: '/autouser/users/:id(\\d+)/perimeter',
        },
        render: () => <PageLayout main={User} subheader={UserSubHeader} />,
    },
    APPLICATIONS: {
        exact: true,
        permissions: ['AUTOUSER_LIST_APP'],
        PATH: '/autouser/applications',
        render: () => <PageLayout main={Applications} subheader={ApplicationsSubHeader} />,
    },
    APPLICATION: {
        exact: true,
        permissions: ['AUTOUSER_CREATE_APP', 'AUTOUSER_EDIT_APP'],
        hasAnyPermissions: true,
        PATH: {
            CREATE: '/autouser/application/new',
            UPDATE: '/autouser/application/:id(\\d+)',
        },
        render: () => <PageLayout main={Application} subheader={ApplicationsSubHeader} />,
    },
    ROLES: {
        exact: true,
        permissions: ['AUTOUSER_LIST_ROLE'],
        PATH: '/autouser/roles',
        render: () => <PageLayout main={Roles} />,
    },
    ROLE: {
        exact: true,
        permissions: ['AUTOUSER_CREATE_ROLE', 'AUTOUSER_EDIT_ROLE'],
        hasAnyPermissions: true,
        PATH: {
            CREATE: '/autouser/role/new',
            UPDATE: '/autouser/role/:id(\\d+)',
        },
        render: () => <PageLayout main={Role} subheader={RolesSubHeader} />,
    },
    HISTORY: {
        exact: true,
        PATH: '/autouser/history',
        permissions: ['AUTOUSER_LIST_HISTORY'],
        render: () => <PageLayout main={History} />,
    },
    LEAD_TAGS: {
        exact: true,
        PATH: '/autouser/lead_tags',
        permissions: ['PARAMETER_MANAGE_FASTNOTES'],
        render: () => <PageLayout main={LeadTags} />,
    },
    ALERTS: {
        exact: true,
        PATH: {
            CURRENT: '/settings/global/alerts/',
            ARCHIVE: '/settings/global/alerts/:status(archive)',
        },
        permissions: ['PARAMETER_MANAGE_ALERTS'],
        render: () => <PageLayout main={Alerts} subheader={AlertSubHeader} />,
    },
    DEALERSHIPS_PERIMETER: {
        exact: true,
        PATH: '/autouser/dealerships',
        permissions: ['PARAMETER_MANAGE_DEALERSHIP'],
        render: () => <PageLayout main={DealershipsPerimeter} />,
    },
    SETTINGS: {
        exact: true,
        PATH: '/settings/:slug(global|apv)',
        permissions: ['PARAMETER_ACCESS_MENU'],
        render: () => <PageLayout main={Settings} subheader={SettingsSubHeader} />,
    },
    STOCK_VEHICLES: {
        exact: true,
        PATH: '/stock/vehicles',
        render: () => <PageLayout main={StockVehicles} subheader={StockVehiclesSubHeader} />,
    },
    STOCK_VEHICLE: {
        exact: true,
        PATH: '/stock/vehicle/:sku',
        render: () => <PageLayout main={StockVehicle} subheader={StockVehicleSubHeader} />,
    },
    STOCK_ACTION_TO_DO: {
        exact: true,
        PATH: '/stock/action-to-do/:page',
        render: () => <PageLayout main={StockActionsToDo} subheader={StockActionsToDoSubHeader} />,
    },
    STOCK_PRICING_TO_DO: {
        exact: true,
        PATH: '/stock/pricing/:page(list|check|history)',
        render: () => <PageLayout main={StockPricingToDo} />,
    },
    CONSOLE_LEADS: {
        exact: true,
        PATH: '/administration/console-leads',
        permissions: ['PARAMETER_ACCESS_CONSOLE'],
        render: () => <PageLayout main={ConsoleLeads} />,
    },
    QUOTATION: {
        exact: true,
        permissions: ['DEV_LIST_ORDER'],
        PATH: '/apv/quotations/:orderType/:id',
        render: () => <PageLayout main={Quotation} subheader={QuotationSubHeader} />,
    },
    QUOTATIONS: {
        exact: true,
        permissions: ['DEV_LIST_ORDER'],
        PATH: '/apv/quotations/:orderType(to_be_appraised|waiting_for_customer|closed)?',
        render: () => <PageLayout main={Quotations} subheader={QuotationsSubHeader} />,
    },
    APV_LEADS: {
        exact: true,
        PATH: '/apv/leads/:statusType(all|new|action_to_do|close)?',
        render: () => <PageLayout main={APVLeads} />,
    },
    CONSOLE_RGPD: {
        exact: true,
        PATH: '/administration/console-rgpd',
        permissions: ['PARAMETER_ACCESS_RGPD_CONSOLE'],
        render: () => <PageLayout main={ConsoleRGPD} subheader={ConsoleRGPDSubHeader} />,
    },
    SERVICES: {
        exact: true,
        PATH: '/administration/services',
        permissions: ['PARAMETER_MANAGE_SERVICES'],
        render: () => <PageLayout main={Services} subheader={ServicesSubHeader} />,
    },
    SERVICE: {
        exact: true,
        permissions: ['AUTOUSER_CREATE_APP', 'AUTOUSER_EDIT_APP'],
        hasAnyPermissions: true,
        PATH: {
            CREATE: '/autouser/service/new',
            UPDATE: '/autouser/service/:slug',
        },
        render: () => <PageLayout main={Service} subheader={ServicesSubHeader} />,
    },
    APV_INSTORE_DETAIL: {
        exact: true,
        PATH: '/apv/orders/:id([0-9a-fA-F\\-]+)',
        render: () => <PageLayout main={APVInStoreOrder} subheader={APVInStoreOrderSubHeader} />,
    },
    DIRECTORY: {
        exact: true,
        PATH: '/directory',
        permissions: ['AUTOUSER_READ_INTERNAL_DIRECTORY'],
        render: () => <PageLayout main={Directory} />,
    },
    BULK_QUOTATION: {
        exact: true,
        PATH: '/administration/bulk-quotation',
        permissions: ['LEAD_ACHAT_CASH_LIST_ALL'],
        render: () => <PageLayout main={BulkQuotation} />,
    },
    CONTACT_INQUIRY: {
        exact: true,
        PATH: '/inquiries/:status(all|new|in_progress|closed)',
        permissions: ['CONTACT_INQUIRY_READ'],
        render: () => <PageLayout main={CustomerContacts} subheader={ContactInquiriesSubHeader} />,
    },
    FINANCING_SIMULATION: {
        exact: true,
        PATH: '/financing/simulation',
        permissions: ['LEAD_CREATE_FINANCING'],
        render: () => <PageLayout main={FinancingSimulation} subheader={false} />,
    },
    FINANCING_LEADS: {
        exact: true,
        PATH: '/financing/leads',
        permissions: ['LEAD_CREATE_FINANCING'],
        render: () => <PageLayout main={FinancingLeads} subheader={false} />,
    },
    FINANCING_WALLET: {
        exact: true,
        PATH: '/financing/wallet',
        permissions: ['LEAD_CREATE_FINANCING'],
        render: () => <PageLayout main={FinancingWallet} subheader={false} />,
    },
    VCU_DUPLICATES: {
        exact: true,
        PATH: '/data-quality/vcu-duplicates',
        permissions: ['DATA_QUALITY_VIEW'],
        render: () => <PageLayout main={VcuDuplicates} subheader={false} />,
    },
};

export default ROUTES;
